// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2deca8fc","239":"e0673f40","455":"e03edef9","488":"fc074816"}[chunkId] + ".chunk.js";
};